<template>
  <div class="home">
    <div v-if="!state.isLoaded" class="loading-wrap">Loading...</div>

    <div v-else>
      <!-- ======= Hero Section ======= -->
      <section id="hero" class="d-flex align-items-center">
        <BanNer />
      </section>

      <!-- ======= about Section ======= -->
      <section id="about" class="about section-bg">
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <h2>{{ tSheet("home.about.title") }}</h2>
            <p class="a-content" style="text-align: left">
              {{ tSheet("home.about.description") }}
            </p>
          </div>

          <div class="row">
            <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div class="icon-box">
                <div class="icon"><i class="bx bxl-dribbble"></i></div>
                <h4>
                  <a href="#" @click.prevent>
                    {{ tSheet("home.about.cards.integration.title") }}
                  </a>
                </h4>
                <p>{{ tSheet("home.about.cards.integration.desc") }}</p>
              </div>
            </div>

            <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div class="icon-box">
                <div class="icon"><i class="bx bx-file"></i></div>
                <h4>
                  <a href="#" @click.prevent>
                    {{ tSheet("home.about.cards.planning.title") }}
                  </a>
                </h4>
                <p>{{ tSheet("home.about.cards.planning.desc") }}</p>
              </div>
            </div>

            <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div class="icon-box">
                <div class="icon"><i class="bx bx-tachometer"></i></div>
                <h4>
                  <a href="#" @click.prevent>
                    {{ tSheet("home.about.cards.resources.title") }}
                  </a>
                </h4>
                <p>{{ tSheet("home.about.cards.resources.desc") }}</p>
              </div>
            </div>

            <div
              class="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div class="icon-box">
                <div class="icon"><i class="bx bx-layer"></i></div>
                <h4>
                  <a href="#" @click.prevent>
                    {{ tSheet("home.about.cards.service.title") }}
                  </a>
                </h4>
                <p>{{ tSheet("home.about.cards.service.desc") }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ======= Order Process Section ======= -->
      <section id="Order-Process" class="Order-Process section-bg">
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <h2>{{ tSheet("home.order.title") }}</h2>
            <div style="display: flex; justify-content: center">
              <p style="text-align: left">
                {{ tSheet("home.order.contactFax") }}
                <a href="tel:+886-4-23292651">04-2329-2651</a>
                <br />
                {{ tSheet("home.order.contactPhone") }}
                <a href="tel:+886-4-23292669">04-2329-2669</a>
                <br />
                E-mail：<a href="mailto:cs@union.com.tw">cs@union.com.tw</a>
              </p>
            </div>
          </div>

          <div class="accordion-list">
            <ul>
              <li v-for="step in orderSteps" :key="step.baseKey">
                <a
                  data-bs-toggle="collapse"
                  :data-bs-target="'#' + step.targetId"
                  :class="step.collapsed ? 'collapsed' : 'collapse'"
                >
                  <span>{{ step.label }}</span> {{ tSheet(step.titleKey) }}
                  <i class="bx bx-chevron-down icon-show"></i>
                  <i class="bx bx-chevron-up icon-close"></i>
                </a>

                <div
                  :id="step.targetId"
                  :class="step.show ? 'collapse show' : 'collapse'"
                  data-bs-parent=".accordion-list"
                >
                  <p>
                    <template
                      v-for="(item, index) in getOrderItems(step.baseKey)"
                      :key="`${step.baseKey}-${index}`"
                    >
                      <strong>{{ index + 1 }}.</strong>{{ item }}
                      <br
                        v-if="index !== getOrderItems(step.baseKey).length - 1"
                      />
                      <br
                        v-if="index !== getOrderItems(step.baseKey).length - 1"
                      />
                    </template>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <!-- ======= FAQ Section ======= -->
      <section id="faq" class="faq section-bg">
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <h2>{{ tSheet("home.faq.title") }}</h2>
          </div>

          <div class="faq-list">
            <ul>
              <li
                v-for="faq in faqItems"
                :key="faq.number"
                data-aos="fade-up"
                :data-aos-delay="faq.delay"
              >
                <i class="bx bx-help-circle icon-help"></i>
                <a
                  data-bs-toggle="collapse"
                  :data-bs-target="'#' + faq.targetId"
                  :class="faq.collapsed ? 'collapsed' : 'collapse'"
                >
                  {{ faq.number }}. {{ tSheet(faq.questionKey) }}
                  <i class="bx bx-chevron-down icon-show"></i>
                  <i class="bx bx-chevron-up icon-close"></i>
                </a>

                <div
                  :id="faq.targetId"
                  :class="faq.show ? 'collapse show' : 'collapse'"
                  data-bs-parent=".faq-list"
                >
                  <p>{{ tSheet(faq.answerKey) }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section id="video" class="form section-bg">
        <ViDeo />
      </section>

      <section id="download" class="download section-bg">
        <DownLoad />
      </section>

      <section id="contact" class="contact">
        <ContactMe />
      </section>

      <div>
        <footer id="footer">
          <!-- <div class="footer-newsletter">
            <div class="container">
              <div class="row justify-content-center"></div>
            </div>
          </div> -->

          <div class="footer-top">
            <div class="container">
              <div class="box row">
                <div class="col-lg-4 col-md-6 footer-links">
                  <h4>{{ tSheet("home.footer.joinTitle") }}</h4>
                  <p>{{ tSheet("home.footer.joinDesc") }}</p>
                  <div class="social-links mt-3">
                    <div
                      class="fb-page"
                      data-href="https://www.facebook.com/Union.Ocean.Co.Ltd/?locale=zh_TW"
                      data-tabs="timeline"
                      data-width=""
                      data-height=""
                      data-small-header="false"
                      data-adapt-container-width="true"
                      data-hide-cover="false"
                      data-show-facepile="true"
                    >
                      <blockquote
                        cite="https://www.facebook.com/Union.Ocean.Co.Ltd/?locale=zh_TW"
                        class="fb-xfbml-parse-ignore"
                      >
                        <a
                          href="https://www.facebook.com/Union.Ocean.Co.Ltd/?locale=zh_TW"
                        >
                          {{ tSheet("home.footer.facebookName") }}
                        </a>
                      </blockquote>
                    </div>
                  </div>
                </div>

                <GoodLink />
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from "vue";
import i18n from "@/i18n";
import DownLoad from "@/components/DownLoad.vue";
import GoodLink from "../components/GoodLink.vue";
import ContactMe from "@/components/ContactMe.vue";
import ViDeo from "@/components/ViDeo.vue";
import BanNer from "@/components/BanNer.vue";

export default {
  name: "HomeView",
  components: { DownLoad, GoodLink, ContactMe, ViDeo, BanNer },

  setup() {
    const state = reactive({
      textMap: {},
      isLoaded: false,
    });

    const orderSteps = [
      {
        label: "STEP 01",
        baseKey: "home.order.step1",
        titleKey: "home.order.step1.title",
        targetId: "accordion-list-1",
        show: true,
        collapsed: false,
      },
      {
        label: "STEP 02",
        baseKey: "home.order.step2",
        titleKey: "home.order.step2.title",
        targetId: "accordion-list-2",
        show: false,
        collapsed: true,
      },
      {
        label: "STEP 03",
        baseKey: "home.order.step3",
        titleKey: "home.order.step3.title",
        targetId: "accordion-list-3",
        show: false,
        collapsed: true,
      },
      {
        label: "STEP 04",
        baseKey: "home.order.step4",
        titleKey: "home.order.step4.title",
        targetId: "accordion-list-4",
        show: false,
        collapsed: true,
      },
    ];

    const faqItems = [
      {
        number: 1,
        delay: 100,
        questionKey: "home.faq.q1.question",
        answerKey: "home.faq.q1.answer",
        targetId: "faq-list-1",
        show: true,
        collapsed: false,
      },
      {
        number: 2,
        delay: 200,
        questionKey: "home.faq.q2.question",
        answerKey: "home.faq.q2.answer",
        targetId: "faq-list-2",
        show: false,
        collapsed: true,
      },
      {
        number: 3,
        delay: 300,
        questionKey: "home.faq.q3.question",
        answerKey: "home.faq.q3.answer",
        targetId: "faq-list-3",
        show: false,
        collapsed: true,
      },
      {
        number: 4,
        delay: 400,
        questionKey: "home.faq.q4.question",
        answerKey: "home.faq.q4.answer",
        targetId: "faq-list-4",
        show: false,
        collapsed: true,
      },
      {
        number: 5,
        delay: 500,
        questionKey: "home.faq.q5.question",
        answerKey: "home.faq.q5.answer",
        targetId: "faq-list-5",
        show: false,
        collapsed: true,
      },
      {
        number: 6,
        delay: 500,
        questionKey: "home.faq.q6.question",
        answerKey: "home.faq.q6.answer",
        targetId: "faq-list-6",
        show: false,
        collapsed: true,
      },
      {
        number: 7,
        delay: 500,
        questionKey: "home.faq.q7.question",
        answerKey: "home.faq.q7.answer",
        targetId: "faq-list-7",
        show: false,
        collapsed: true,
      },
      {
        number: 8,
        delay: 500,
        questionKey: "home.faq.q8.question",
        answerKey: "home.faq.q8.answer",
        targetId: "faq-list-8",
        show: false,
        collapsed: true,
      },
    ];

    const fetchData = async () => {
      const sheetID = "1IFviuC_us32IipSQBXDS4EivpU53ftnK3NYPl202_9U";
      const apiKey = "AIzaSyD21a6U3dc4wpee6BCu4D-pxnPff9QSW4w";
      const sheetName = "HomeView_i18n";
      const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetID}/values/${encodeURIComponent(
        sheetName,
      )}?alt=json&key=${apiKey}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        console.log("Sheet data:", data);

        if (!data.values || !Array.isArray(data.values)) {
          console.error("Google Sheet 資料格式不正確:", data);
          return;
        }

        state.textMap = convertSheet(data.values);
        state.isLoaded = true;
      } catch (err) {
        console.error("讀取 HomeView Google Sheet 失敗:", err);
      }
    };

    const convertSheet = (rows) => {
      const headers = rows[0] || [];

      const keyIndex = headers.indexOf("Key");
      const zhIndex = headers.indexOf("zh");
      const enIndex = headers.indexOf("en");

      const result = {};

      rows.slice(1).forEach((row) => {
        const key = row[keyIndex];
        if (!key) return;

        result[key] = {
          zh: row[zhIndex] || "",
          en: row[enIndex] || "",
        };
      });

      return result;
    };

    const tSheet = (key) => {
      const item = state.textMap[key];
      if (!item) return "";

      const currentLocale = i18n.global.locale;
      const localeValue =
        typeof currentLocale === "string" ? currentLocale : currentLocale.value;

      return localeValue === "en" ? item.en || item.zh || "" : item.zh || "";
    };

    const getOrderItems = (stepBaseKey) => {
      const items = [];

      for (let i = 1; i <= 4; i += 1) {
        const value = tSheet(`${stepBaseKey}.item${i}`);
        if (value) items.push(value);
      }

      return items;
    };

    onMounted(() => {
      fetchData();
    });

    return {
      state,
      tSheet,
      orderSteps,
      faqItems,
      getOrderItems,
    };
  },
};
</script>

<style>
.nav-pills {
  margin-bottom: 30px;
}

.box {
  justify-content: center;
  align-content: center;
}

.loading-wrap {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
